var $ = jQuery.noConflict();

// JQ call variables
const mnuBtnBurger = $('.mnu-btn-burger'),
searchPanel = $('.search-panel'),
searchField = $('.search-field'),
searchClear = $('.search-clear'),
htmlBody = $('html, body'),
menuPrimaryFirst = $('ul#menu-primary li:first'),
navPanels = $('div .nav-panels'),
navPanelInnerFirst = $('div.nav-panels>.inner>div:first'),
menuPrimaryLi = $('ul#menu-primary li'),
bodySelector = $('body'),
pageOpacity = $('.page-opacity'),
headerNavigation = $("header .navigation"),
navPanelSelector = $('.nav-panel'),
navPanelsInner = $('.nav-panels>.inner'),
burgerNavInner = $('.burger-nav>.inner'),
headerLogo = $('header .logo'),
mobileUtilNav = $('.mobile-utility-nav'),
megaBack = $('.mega-back');

const mobileBreak = 1025;
let menuMarkertop;
let menuMarkerleft;


//Override "scroll" jump link pt 1/2 (tabbed pages)
var scroll_disabled = false;
if(window.location.hash == "#scroll") {
    scroll_disabled = true;
    window.location.hash = "";
    history.replaceState("", document.title, window.location.pathname);
}




$(document).ready((g)=>{
    let prevScrollpos = window.pageYOffset;
	let barheight = document.getElementById("header-nav-bar").offsetHeight;

    // Disable animations on mobile
    AOS.init({disable: 'mobile'});

    //Override "scroll" jump link pt 2/2 (tabbed pages)
    if(scroll_disabled == true) {
        let new_offset = $(".page-content-tabbed #scroll").offset().top - barheight - 50;
        htmlBody.delay(200).animate({
            scrollTop: new_offset,
            }, 500, 'linear'
        )
    } else {
        // if(window.location.hash && $(window.location.hash).length && window.location.hash!= "#scroll") {
        //     htmlBody.delay(200).animate({
        //         scrollTop: $(window.location.hash).offset().top,
        //         }, 500, 'linear'
        //     )
        // }
    }

    // Smooth Scrolling on CLICK
    $('a[href*="#"]').on('click', function(e) {
        // console.log('aaaa' + $(this).parents('#header-nav-bar').length);
        // if(!$(this).parents('#header-nav-bar').length && !$(this).parents('.burger-nav').length) {
        //     if(!$(this).hasClass('not-jumpdown')) {
        //         htmlBody.animate({
        //             scrollTop: $($(this).attr('href')).offset().top,
        //             }, 500, 'linear'
        //         )
        //     } else {
        //         e.preventDefault();
        //     }
        //     console.log('yes parent element');
        // } else {
        //     console.log('no parent element');
        // }
    });



    var $backToTop = $('.back-to-top');

    // Show/hide the button based on scroll position
    $(window).scroll(function () {
        if ($(this).scrollTop() > $(window).height() * 2) {
            $backToTop.fadeIn();
        } else {
            $backToTop.fadeOut();
        }
    });

    // Smooth scroll to top
    $backToTop.on('click', function(e) {
        $('html, body').animate({ scrollTop: 0 }, 500, 'linear');
        return false;
    });



    
    // Sticky menu bar

    window.onscroll = function() {
		if($(".primary .dropdown-outer").hasClass('active')){
            $('.primary .dropdown-toggle').click();
        }
        let currentScrollPos = window.pageYOffset;
	if (prevScrollpos > currentScrollPos || window.pageYOffset < 50) {
		document.getElementById("header-nav-bar").style.top = "0";
	} else {
        if(!$(".single-page-tabbed").length) {
    		document.getElementById("header-nav-bar").style.top = "-" + barheight + "px";
        }
	}
		prevScrollpos = currentScrollPos;
	}



    // Menu Active states
    function menuActive(toggle, breakpoint = mobileBreak){
        if(toggle == true){
            bodySelector.addClass('menu-active');
            mnuBtnBurger.find('span.label').text('CLOSE');
            mnuBtnBurger.addClass('mnu-active');
            if( $(window).width() < mobileBreak ){
                headerNavigation.find('.mnu-btn-search').hide();
            }
        }else{
            bodySelector.removeClass('menu-active');
            mnuBtnBurger.find('span.label').text('MENU');
            mnuBtnBurger.removeClass('mnu-active');
            if( $(window).width() < mobileBreak ){
                headerNavigation.find('.mnu-btn-search').show();
            }
        }
    }

    menuPrimaryFirst.addClass('active');
    navPanelInnerFirst.addClass('active');
    menuPrimaryLi.each(function(){
        if($(this).hasClass('current-section')){
            menuPrimaryLi.removeClass('active');
            $(this).addClass('active');
            let thePanel = $(this).data('mnu-cat');
            let allPanels = navPanelSelector;
            allPanels.removeClass('active');
            allPanels.each(function(){
                if($(this).data('mnu-cat') == thePanel){
                    $(this).addClass("active");
                }
            });
            return false;

        }
    });
    
    window.onresize = menuActive(false);

    // Burger Menu
    mnuBtnBurger.on('click', (e)=>{
        if(searchPanel.css('display') == 'block'){
            searchPanel.hide();
            menuActive(false);
            pageOpacity.fadeToggle(200);
        }else{
            if(bodySelector.hasClass('menu-active')){
                bodySelector.css('position', 'relative');
                bodySelector.css('overflow-y', 'auto');
                megaBack.css('padding', '0');
                megaBack.css('width', '0');
                megaBack.css('visibility', 'hidden');
                menuActive(false);
                navPanelSelector.delay(700).removeClass('active');
                menuPrimaryLi.delay(700).removeClass('active');
                menuPrimaryFirst.delay(700).addClass('active');
                navPanelInnerFirst.delay(1200).addClass('active');
                
            } else {
                menuActive(true);
                if( $(window).width() >= mobileBreak ){
                    bodySelector.css('position', 'fixed');
                    bodySelector.css('overflow-y', 'scroll');
                }
        
            }

            $('.burger-nav').fadeToggle(200);

            if( $(window).width() >= mobileBreak ){
                menuMarkertop = jQuery('#menu-primary .active').offset().top + jQuery('#menu-primary .active').height() + 10;//menuPrimaryFirst.offset().top + menuPrimaryFirst.height() + 8;
                menuMarkerleft = jQuery('#menu-primary .active').offset().left + ((jQuery('#menu-primary .active').width() / 2) -90);//menuPrimaryFirst.offset().left + ((menuPrimaryFirst.width() / 2) -90);
                $('#menu-active-marker').css( { top: menuMarkertop, left: menuMarkerleft, display : 'block'  });
            }

            pageOpacity.fadeToggle(200);
            if( $(window).width() < mobileBreak ) {
                burgerNavInner.css('margin-left', '0');
                burgerNavInner.height(260);
            }
        }
    });

    $('.page-opacity, .burger-nav a').click(()=>{
        mnuBtnBurger.click();
    });

    menuPrimaryLi.click((e)=>{        
        
        let clickedPanel = $(e.target).data('mnu-cat');
        if( $(window).width() < mobileBreak ) {
            mobileUtilNav.fadeOut();
            menuPrimaryLi.removeClass('active');
            $(e.target).addClass('active');
            navPanelSelector.removeClass('active');
            navPanelSelector.each(function(){
                if($(this).data('mnu-cat') == clickedPanel){
                    $(this).addClass("active");
                    burgerNavInner.animate({height: $(this).height() +20}, 100);
                }
            });
            burgerNavInner.animate({marginLeft: '-100%'}, 500);
            megaBack.css('width', 'auto');
            megaBack.css('padding', '3px 10px');
            megaBack.css('visibility', 'visible');
        }else{
            navPanelsInner.fadeOut(400, ()=>{
                menuPrimaryLi.delay(700).removeClass('active');
                $(e.target).addClass('active');
                navPanelSelector.removeClass('active');
                navPanelSelector.each(function(){
                    if($(this).data('mnu-cat') == clickedPanel){
                        $(this).addClass("active");
                        //burgerNavInner.animate({height: $(this).height() +50}, 300);
                        
                    }
                });
            });

            menuMarkertop = $(e.target).offset().top + $(e.target).height() + 10;
            menuMarkerleft = $(e.target).offset().left + (($(e.target).width() / 2) -90);
            $('#menu-active-marker').stop().animate( { top: menuMarkertop, left: menuMarkerleft  }, 500 );
        
        }
        
        navPanelsInner.fadeIn(400);
    });

    megaBack.click(()=>{
        if( $(window).width() < mobileBreak ) { 
            burgerNavInner.animate({marginLeft: '0'}, 500);
            menuPrimaryLi.removeClass('active');
            navPanelSelector.removeClass('active');
            mobileUtilNav.fadeIn();
            burgerNavInner.animate({height: 260}, 300);
            megaBack.css('visibility', 'hidden');
        }
    });



    // I AM A dropdown menu
    $('.primary .dropdown-toggle').click(function(e) {
        $(".primary .dropdown-outer #dropLabel").text($(this).data("default-label"));
        e.preventDefault();
        e.stopPropagation();
        $(".primary .dropdown-outer").toggleClass('active');

        $(document).on('click', function closeMenu (e){
            if($('.primary .dropdown-outer.active').has(e.target).length === 0){
                $(".primary .dropdown-outer").removeClass('active');
            }
        });
    });

    $('.primary .dropdown-item a').click(function() {
        $(".primary .dropdown-outer #dropLabel").text($(this).text());
        $(".primary .dropdown-outer").removeClass('active');
    });

    //Search button
    $('.mnu-btn-search').on('click', (e)=>{
        searchField.val('');
        menuActive(true);
        searchPanel.fadeToggle(200);
        pageOpacity.fadeToggle(200);
        $('.search-field').focus();
    });

    var searchKeypress = true;
    searchClear.click(function(e) {
        e.preventDefault();
        searchField.val('');
        $(this).removeClass('show');
        searchKeypress = true;
     });

    searchField.keydown(function(e) {
        if (e.keyCode === 13) {
            $('.search-form').submit();
        } else if (searchKeypress) {
            searchClear.addClass('show');
            searchKeypress = false;
        }
    });

    
    /* ################## JS Routing ################## */ 

    /*************** Resources Library ****************/
    if($("main.resource-library").length) {
        var sortfacet = 'resources_sort_by';

        $(document).on('click', '.sort-radio', function() {
            var val = $(this).attr('data-value');
            FWP.facets[sortfacet] = [val];
            FWP.toggleOverlay('on'); 
            FWP.fetchData();
            FWP.setHash();
        });


        $(document).on('click', '.view-mode .toggle-display', function() {
            $(".listing-results").attr("data-display", $(this).data("display"));
        });
        

        $(document).on('facetwp-loaded', function() {
            if ('undefined' !== typeof FWP.facets[sortfacet]) {
                $('.sort-radio').filter('[data-value="' + FWP.facets[sortfacet] + '"]').addClass("checked");
            
                //show default sort of 'date' as selected
                if(FWP.facets[sortfacet] == "") {
                    $(".hide-circle [data-value='sort_date']").addClass('checked');
                }
            }
        });
     /************* END Resources Library *************/

     /*************** Tabbed Content ****************/
    } else if($(".page-content-tabbed").length) {
        var tabSet = $('.horizontal-nav .navbar').scrollTabs();
        var currentPath = window.location.pathname.replace(/\/$/, '').toLowerCase();
        $('.horizontal-nav .navbar a').each(function() {
        var href = $(this).prop('pathname').split("#")[0].replace(/\/$/, '').toLowerCase();
        if (href === currentPath) {
            $(this).parent().attr('class', 'scroll_tab_over tab_selected');
        }
        });

        $('.horizontal-nav .navbar a').click(function(e) {
            if (href === currentPath) {
                e.preventDefault();
            }
        });
     /************* END Tabbed Content **************/
     
    }

    navPanelSelector.find('a').click(function(){
        megaBack.css('visibility', 'hidden');
        megaBack.css('width', '1px');
    });
   

    


var hash = window.location.hash;
if (hash) {
  var anchor = jQuery(hash);
  var sectionID = hash.split("#")[1];

  // Find the next sibling that could be either .accordion-group or .accordion-block
  var targ = jQuery(anchor).next(".accordion-group, .accordion-block");

  if (targ.length) {
    // Step 1: Open the accordion first
    openAccordion(targ);

    // Step 2: Scroll to the section after opening the accordion
    scrollToSection(sectionID);
  }
}

// Function to scroll to the section with a callback when done
function scrollToSection(sectionID) {
  const headerHeight = document.querySelector("header").offsetHeight;
  var target = jQuery("#" + sectionID);
  if (target.length) {
    jQuery("html, body").animate(
      {
        scrollTop: target.offset().top - headerHeight,
      },
      1000
    );
  }
}

// Function to open the accordion
function openAccordion(targ) {
  jQuery(targ).find(".accordion-btn").addClass("active");
  jQuery(targ).find(".accordion-panel").addClass("active");
  jQuery(targ).find(".accordion-panel").css("max-height", "none");
}


});